import React from 'react';
import { useApp } from '../../../context/usePortal';

const Greeting: React.FC = () => {
  // Function to get the current greeting based on local time
  const { user } = useApp();
  const getGreeting = (): string => {
    const hours = new Date().getHours();
    if (hours < 12) {
      return 'Good Morning';
    } else if (hours < 18) {
      return 'Good Afternoon';
    } else {
      return 'Good Evening';
    }
  };

  // Get the greeting message
  const greetingMessage = user?.user_name
    ? `${getGreeting()}, ${user.user_name}!`
    : `${getGreeting()}!`;

  return (
    <div className="px-4 pt-4 sm:px-6 lg:px-8">
      <h1 className="xs:text-2xl mb-5 font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:leading-9">
        {greetingMessage}
      </h1>
    </div>
  )
};

export default Greeting;
